module.exports = __webpack_public_path__ + "img/TechInfAttack3_ua.b0b7bc39.webp";